import { type ReactNode } from 'react'
import { Bold, Code2, Highlighter, Italic, Strikethrough, Subscript, Superscript, Underline } from 'lucide-react'
import type { BlockType, ToolbarState } from '@/features/contract/types/toolbar.ts'

export const FORMAT_BUTTONS: Array<{
  format: keyof ToolbarState['formats']
  icon: ReactNode
  label: string
}> = [
  { format: 'bold', icon: <Bold aria-hidden size={14} />, label: '粗体' },
  { format: 'italic', icon: <Italic aria-hidden size={14} />, label: '斜体' },
  { format: 'underline', icon: <Underline aria-hidden size={14} />, label: '下划线' },
  { format: 'strikethrough', icon: <Strikethrough aria-hidden size={14} />, label: '删除线' },
  { format: 'subscript', icon: <Subscript aria-hidden size={14} />, label: '下标' },
  { format: 'superscript', icon: <Superscript aria-hidden size={14} />, label: '上标' },
  { format: 'highlight', icon: <Highlighter aria-hidden size={14} />, label: '高亮' },
  { format: 'code', icon: <Code2 aria-hidden size={14} />, label: '行内代码' }
]

export const BLOCK_OPTIONS: Array<{ label: string; value: BlockType }> = [
  { label: '正文', value: 'paragraph' },
  { label: '标题 1', value: 'h1' },
  { label: '标题 2', value: 'h2' },
  { label: '标题 3', value: 'h3' },
  { label: '引用', value: 'quote' },
  { label: '项目列表', value: 'bullet' },
  { label: '编号列表', value: 'number' },
  { label: '待办列表', value: 'check' },
  { label: '代码块', value: 'code' }
]

export const DEFAULT_TOOLBAR_STATE: ToolbarState = {
  alignment: '',
  blockType: 'paragraph',
  fontFamily: '',
  fontSize: '14px',
  formats: {
    bold: false,
    code: false,
    highlight: false,
    italic: false,
    strikethrough: false,
    subscript: false,
    superscript: false,
    underline: false
  }
}
